<template>
  <div class="checklists">
    <div class="checklists__wrapper">
      <ChecklistsChecklist
        v-for="(checklist, idx) in checklists"
        :id="`checklist-${checklist.id}`"
        :key="checklist.id"
        :checklist="checklist"
        :class="statusControlClass(idx)"
        :data-id="checklist.id"
        data-type="checklist"
      />
    </div>
    <!-- action button -->
    <ChecklistsAddAction
      v-allowed:employee
      v-if="isEditable"
      @added="addChecklist"
      text="Añadir checklist"
    />
  </div>
</template>

<script>
// Utilities
import { EventBus } from '@/main'
import ChecklistsMixin from './mixins'
import { arraySortByObjectKey, ToNextElementOrder } from 'Utils'
import ChecklistItemProto from './classes/checklistPrototype'
// Components
import ChecklistsChecklist from './components/ChecklistsChecklist'
import ChecklistsAddAction from './components/ChecklistsAddAction'

export default {
  name: 'Checklists',

  components: {
    ChecklistsChecklist,
    ChecklistsAddAction,
  },

  props: {
    listing: {
      type: Array,
      required: true,
    },
  },

  mixins: [ChecklistsMixin],

  methods: {
    async addChecklist(values) {
      // ADDING NEW CHECKLIST
      const newChecklist = this.getChecklistData({
        checklistValues: new ChecklistItemProto({
          title: values.title,
          order: ToNextElementOrder(this.checklists[this.checklists.length - 1]?.order),
        }),
      })
      await this.$store.dispatch('checklists/addChecklist', newChecklist)
    },
  },

  computed: {
    checklists() {
      const orderedChecklists = arraySortByObjectKey(
        this.$store.state.checklists.checklists,
        'order'
      )
      return orderedChecklists
    },

    statusControlClass() {
      return (idx) => {
        return idx < this.checklists.length - 1 && !this.isTemplatePage ? 'progress-bar' : ''
      }
    },
  },

  beforeMount() {
    this.$store.dispatch('checklists/load', this.listing)
  },

  created() {
    // UPDATING ORDERS
    // Get checklists/items updated order
    const getUpdateInfo = (draggedInfo, extraParams) => {
      const updatedItem = draggedInfo.sortableItem
      const actionType = updatedItem.isTemplatePage ? 'templates' : 'card'
      // preparing requested values for API call
      const itemInfo = {
        cardId: this.$route.params.card_id || this.$route.params.temp_id,
        actionType,
        ...extraParams,
        newData: {
          order: draggedInfo.newElementOrder,
        },
      }
      return itemInfo
    }
    // updating item's order
    EventBus.$on('item-dragged', async (draggedInfo) => {
      const itemInfo = getUpdateInfo(draggedInfo, {
        checklistId: draggedInfo.sortableItem.item.checklist,
        itemId: draggedInfo.sortableItem.item.id,
      })
      await this.$store.dispatch('checklists/updateItem', itemInfo)
    })
    // updating checklist's order
    EventBus.$on('checklist-dragged', async (draggedInfo) => {
      const itemInfo = getUpdateInfo(draggedInfo, {
        checklistId: draggedInfo.sortableItem.checklist.id,
      })
      await this.$store.dispatch('checklists/updateChecklist', itemInfo)
    })
  },

  beforeDestroy() {
    // Removen events
    EventBus.$off('checklist-dragged')
    EventBus.$off('item-dragged')
  },
}
</script>

<style scoped></style>
